import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

interface IMemberProjectProps {
  showMemberModal: boolean;
  onCloseModal: () => void;
  onHandleInviteMember: () => void;
}

const MemberProjectModal = ({
  showMemberModal,
  onCloseModal,
  onHandleInviteMember,
}: IMemberProjectProps) => {

  // Only for dummy, please remove if unused again!
  const users = [
    { id: 1, email: "user1@rolerelay.com", status: "ACTIVE" },
    { id: 2, email: "user2@rolerelay.com", status: "ACTIVE" },
    { id: 3, email: "user3@rolerelay.com", status: "DEACTIVATE"},
  ];

  const handleInviteMember = () => {
    onCloseModal();
    onHandleInviteMember();
  }

  return (
    <Dialog open={showMemberModal} onOpenChange={onCloseModal}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Project Members</DialogTitle>
        </DialogHeader>
        <div>
          {/* <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-1/2">Email</TableHead>
                <TableHead className="w-1/4 text-center">Status</TableHead>
                <TableHead className="w-1/4 text-center">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map(({id, email, status}) => (
                <TableRow key={id}>
                  <TableCell>{email}</TableCell>
                  <TableCell className="text-center">{status}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table> */}
        </div>
        <DialogFooter>
          <Button
            variant="default"
            onClick={handleInviteMember}
          >
            Invite Member
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default MemberProjectModal;
